export var isArray = function (value) {
    return value instanceof Array;
};
//# sourceMappingURL=isArray.js.map